import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ForgotPasswordService } from '@shared/services/forgot-password.service';
import { SnackbarFactory, ThemeService } from '@shared/services';

@Component({
  selector: 'app-forgot-password-change',
  templateUrl: './forgot-password-change.component.html',
  styleUrls: ['./forgot-password-change.component.scss'],
})
export class ForgotPasswordChangeComponent implements OnInit {
  public isIdValid = false;
  public hide = true;
  public passwordIsValid = false;
  public passwordErrors = [] as string[];
  public passwordAgainErrors = [] as string[];
  public formGroup = new FormGroup({
    id: new FormControl('', [Validators.required]),
    username: new FormControl({ value: '', disabled: true }, [
      Validators.required,
    ]),
    password: new FormControl('', [Validators.required]),
    passwordAgain: new FormControl('', [Validators.required]),
  });

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    public forgotPwdService: ForgotPasswordService,
    private translate: TranslateService,
    private snackBar: SnackbarFactory,
    public themeService: ThemeService,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.formGroup.controls.id.setValue(params.g);
    });

    this.forgotPwdService
      .getPwdChange(this.formGroup.value.id)
      .subscribe((res) => {
        this.isIdValid = true;
        this.formGroup.controls.username.setValue(res.username);
      });
  }

  backToLogin() {
    this.router.navigateByUrl('/login', { replaceUrl: true });
  }

  onSubmit() {
    this.passwordAgainErrors = [];
    if (this.formGroup.value.password !== this.formGroup.value.passwordAgain) {
      this.passwordAgainErrors.push('pwds-not-match');
      return;
    }

    this.forgotPwdService
      .submitPwdChange(this.formGroup.getRawValue())
      .subscribe({
        error: (err) => {
          this.snackBar.showButtonSnackbar(err);
        },
        next: (res) => {
          this.snackBar.showButtonSnackbarWithText(200, this.translate.instant('pwd-change-success'));
          this.backToLogin();
        },
        complete: () => { },
      });
  }

  preventPaste(e: Event) {
    e.preventDefault();
  }

  passwordValid(event) {
    this.passwordIsValid = event;
  }

  getPasswordErrors(event) {
    this.passwordErrors = event;
  }
}
